import React from "react";
import QRCode from "qrcode.react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import "./InviteInduction.scss";
import { Toast } from "antd-mobile";
import { getItem } from "../../util/util";
import withAuth from "../../HOCs/withAuth";
import GoBack from "../../components/GoBack";

class InviteInduction extends React.Component {
  state = {
    url: `${window.host}/register?invitecode=${
      JSON.parse(getItem("userInfo")).UserInfo.EMP_USERCODE
    }`,
    name: `${JSON.parse(getItem("userInfo")).Data}`
  };
  componentDidMount() {
    // console.log(this.state.url);
    // console.log(window.innerHeight, window.innerWidth);
  }

  render() {
    return (
      <div className="invite-induction">
        <p
          style={{
            // color: "#1890ff",
            textDecoration: "underline",
            textAlign: "center"
          }}
        >
          <span style={{ fontSize: "2.44vh" }}>
            请将此页面<span style={{ color: "#f5222d" }}>截图</span>
          </span>
          <br />
          将截图分享至朋友圈，或发送给身边的朋友……
        </p>
        <div className="invite-induction__bg">
          <div className="invite-induction__bg__circle1"></div>
          <div className="invite-induction__bg__circle2"></div>
          <div className="invite-induction__bg__circle3"></div>
          <div className="invite-induction__bg__circle4"></div>
        </div>
        <div className="invite-induction__wrapper">
          <GoBack
            goBack={() => {
              this.props.history.push("/personal_center");
            }}
          />
          <header>
            <div>
              <h1>找工作</h1>
              <h1>外企菲尼萨就是你的首选</h1>
            </div>
          </header>
          <section className="invite-induction__employee-info">
            <div className="invite-induction__employee-info__container">
              <QRCode
                value={this.state.url}
                size={window.innerWidth * 0.2613}
              />
              <span className="wechat-avator">
                <img src={getItem("headurl")} alt="微信头像" />
              </span>
              <span className="employee-info__name">{this.state.name}推荐</span>
            </div>
          </section>
          <section className="invite-induction__bottom">
            <div className="scan-qrcode-reminder">
              赶紧扫描上面二维码求职，我们等你来
            </div>
            <p>入职后将拥有</p>
            <p>
              <strong>高底薪、高收入</strong>的工作
            </p>
            <p>享受</p>
            <p style={{ marginBottom: "3.29vh" }}>
              <strong>各种津贴、社保公积金、商业保险</strong>
            </p>
            <p>还有</p>
            <p>免费班车接送上下班、</p>
            <p>带独立卫生间的公寓式宿舍、</p>
            <p>免费工作餐、</p>
            <p>四季如春的工作环境......</p>
          </section>
          <footer className="invite-induction__footer">
            咨询电话：0510-68007800-7632、7631
          </footer>
        </div>
        {/* <div className="copy_link">
            <div className="copy_btn">
              <CopyToClipboard
                text={this.state.url}
                onCopy={(text, result) => {
                  if (result) {
                    Toast.success("已复制到剪贴板");
                  } else {
                    Toast.fail("复制失败");
                  }
                }}
              >
                <img src="/assets/images/share-link.svg" alt="" />
              </CopyToClipboard>
            </div>
            <p>复制链接</p>
          </div> */}
      </div>
    );
  }
}

export default withAuth(InviteInduction);
